import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "react-toastify/dist/ReactToastify.css";
import smartfmImg from "../Assets/sm.png";
import nanosoftImg from "../Assets/ns.png";
import userIcon from "../Assets/userIcon.svg";
import passIcon from "../Assets/passIcon.svg";
import { IoMdRefresh } from "react-icons/io";

import 'typeface-lato';


export default function Login() {
    const navigate = useNavigate();
    const [jsonData, setJsonData] = useState(null);
    const [captchaImage,setCaptchaImage]=useState(null)
    const [state, setState] = useState({
        UserEmail: "",
        Password: "",
        captcha:""
    });
    const [showPassword, setShowPassword] = useState(false);


    useEffect(()=>{
        const baseUrl = window.location.origin;

        if(baseUrl.includes('localhost')){
            localStorage.setItem('domain','https://saas.smartfm.in')
        }else{
            localStorage.setItem('domain',baseUrl)
        }

    },[])

    useEffect(() => {
        if (localStorage.getItem("token")){
            navigate("/")
        }
    }, [navigate]);

    useEffect(()=>{
        fetchCaptchaImage()
    },[])

  const fetchCaptchaImage = () => {
    fetch(`${process.env.REACT_APP_NODE_SERVICE}/captcha?t=${Date.now()}`)  
        .then((res) => { return res.json() })
        .then((res) => {
            if (res?.Output?.status?.code == 200 && res?.Output?.data) {
                setCaptchaImage(res?.Output?.data)
                setState(prev => ({ ...prev, captcha: "" }))  
            }
        })
}


    const url =`${process.env.REACT_APP_NODE_SERVICE}/LoginJson`
    useEffect(() => {
        fetch(url)
            .then((res) => res.json())
            .then((result) => {
                setJsonData(result);
            })
            .catch((err) => {
                console.error("Error fetching data:", err);
            });
    }, []);
    const getJson = jsonData?.Output?.data[0]

    const handleLogin = () => {
        if (!state.UserEmail || !state.Password) {
            toast.warn("Please enter username and password");
            return;
        }

        if (!state.captcha) {
            toast.warn("Please enter captcha");
            return;
        }
        
        const url = process.env.REACT_APP_NODE_SERVICE + '/Login';
        const params = {
            data: {
                p1: state.UserEmail,
                p2: btoa(state.Password),
                p3: btoa(state.captcha)
            }
        };

        fetch(url, {
            method: "POST",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "txt":captchaImage?.text || ''
            },
            body: JSON.stringify(params)
        })
            .then((res) => res.json())
            .then((res) => {
                if (res?.Output?.data?.UserEmail && res?.Output?.data?.loginStatus === "1") {
                    localStorage.setItem("token", res.Output.data.UserEmail);
                    localStorage.setItem("userid", res.Output.data.userid);
                    toast.success("Login successful");
                    setTimeout(() => navigate("/home"), 1000);
                } else {
                    toast.error(res?.Output?.data?.message || "Invalid username or password");
                    fetchCaptchaImage()
                }
            })
            .catch((err) => {
                console.error("Login error:", err);
                toast.error("Something went wrong, please try again");
            });
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            handleLogin();
        }
    };

    const handleClickShowPassword = () => {
        setShowPassword((prev) => !prev);
    };

    const hanleOpenSignUp = () =>{
        navigate('/signup')
    }


    return (
        <div
            style={{
                fontFamily: 'Lato',
                position: 'relative',
                letterSpacing: '0.5px'
            }}
        >
            {/* Request Access Button */}
            {/* <div style={{ position: 'absolute', bottom: '40px', left: '40px', zIndex: '10' }}>
                <a href="https://smartfm.ae/RequestDemo.html" className="RequestDemoBtn">
                    <svg width="190" height="55">
                        <defs>
                            <linearGradient id="grad1">
                                <stop offset="0%" stopColor="#41B152" />
                                <stop offset="100%" stopColor="#3973BC" />
                            </linearGradient>
                        </defs>
                        <rect
                            x="5"
                            y="5"
                            rx="25"
                            fill="none"
                            stroke="url(#grad1)"
                            width="179"
                            height="42"
                        />
                    </svg>
                    <span>Request Access</span>
                </a>
            </div> */}

            <div className="login-container">
                <div className="loginClip"
                    style={{
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        zIndex: 0,
                        width: '200px',
                        height: '200px',
                        background: 'linear-gradient(180deg, #274633 0%, #3C694D 100%)',
                        clipPath: 'circle(79.7% at 17% 63%)',
                    }}
                ></div>
                <div className="loginClip"
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        zIndex: 100,
                        width: '200px',
                        height: '200px',
                        background: 'linear-gradient(150deg, #274633 0%, #3C694D 100%)',
                        clipPath: 'circle(69.7% at 64% 15%)',
                    }}
                ></div>
                <div className="section">
                    {/* Left Section */}
                    <div className="left-section">
                        <div className="infographic-box">
                            <img src={getJson?.image} alt="infographicImages" style={{ width: '75%', height: '75%'}}></img>
                        </div>
                        <h2 className="left-title">{getJson?.title}</h2>
                        <p className="left-text">
                            {getJson?.content}
                        </p>
                    </div>

                    {/* Right Section */}
                    <div className="right-section" >
                        <div className="login-card">
                            <img
                                src={smartfmImg}
                                alt="Logo"
                                className="sm-logo"
                            />
                            <p
                                style={{
                                    textAlign: 'center',
                                    color: '#6F7C86',
                                    margin: 0,
                                }}
                            >
                                by
                            </p>
                            <img
                                src={nanosoftImg}
                                alt="Logo"
                                className="ns-logo"
                            />
                            <div className="welcome-text">Welcome</div>
                            <div className="login-subtext">Login to your account</div>

                            {/* Username Field */}
                            <div className="form-group">
                                <label htmlFor="username">User Email</label>
                                <div className="input-container">
                                    <span className="input-icon">
                                        <img src={userIcon} alt="User icon" />
                                    </span>
                                    <input
                                        type="text"
                                        id="username"
                                        placeholder="Enter username"
                                        value={state.UserEmail}
                                        onChange={(e) => setState({ ...state, UserEmail: e.target.value })}
                                        onKeyDown={handleKeyDown}
                                    />
                                </div>
                            </div>

                            {/* Password Field */}
                            <div className="form-group">
                                <label htmlFor="password">Password</label>
                                <div className="input-container">
                                    <span className="input-icon">
                                        <img src={passIcon} alt="Password icon" />
                                    </span>
                                    <input
                                        type={showPassword ? "text" : "password"}
                                        id="password"
                                        placeholder="Enter password"
                                        value={state.Password}
                                        onChange={(e) => setState({ ...state, Password: e.target.value })}
                                        onKeyDown={handleKeyDown}
                                    />
                                    <span
                                        className="toggle-password"
                                        onClick={handleClickShowPassword}
                                    >
                                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                    </span>
                                </div>
                            </div>
                            <div className="captch-div">
                                <div className="captcha-space-between">
                                    <div
                                        dangerouslySetInnerHTML={{ __html: captchaImage?.img || "" }}
                                        style={{height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}}
                                        className="captcha"
                                    />
                                    <div className="recaptcha">
                                        <IoMdRefresh style={{width:'30px',height:'100%' ,cursor:'pointer'}} onClick={()=>{fetchCaptchaImage()}}/>
                                    </div>
                                </div>

                                 <div className="input-container">
                                    <input
                                        type="text"
                                        id="username"
                                        style={{paddingLeft:'10px'}}
                                        placeholder="Enter Captcha"
                                        value={state.captcha}
                                        onChange={(e) => setState({ ...state, captcha: e.target.value })}
                                        onKeyDown={handleKeyDown}
                                    />
                                </div>

                            </div>

                            <div className="login-options">
                                <label>
                                    <input type="checkbox" /> Remind me
                                </label>
                                {/* <a href="/forgot-password" className="forgot-link">Forgot Password</a> */}
                            </div>


                            <button
                                className="sign-in-btn"
                                onClick={handleLogin}
                            >
                                Sign in
                            </button>

                            {/* Sign Up Text */}
                            <div className="signup-text mt-4 underline cursor-pointer" onClick={hanleOpenSignUp}>
                                Do you want to <a  >Sign up?</a>
                            </div>

                            {/* Footer Links */}
                            <div className="footer-links">
                                <a href="/">Terms and conditions</a>
                                <a href="https://smartfm.ae/PrivacyPolicy.html">Privacy Policy</a>
                            </div>
                            <ToastContainer
                                position="top-center"
                                autoClose={2000}
                                hideProgressBar
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}